import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

import { InAppTemplate } from "../../../shared/templates/inapp";

import { history } from "../../../shared/_helpers/history";

import "../index.scss";
import { AlertMsg } from "../../../shared/components/alert-msg";
import { LoadingItem } from "../../../shared/components/loading";
import { useToast } from "../../../shared/context/ToastContext";
import { storeActions } from "../../../redux/actions/in-app";

import {
  EditProductForm,
  MainHeader,
  getProductDetail,
  getMetadata,
  addNewProduct,
  editProduct,
  getImagesGallery,
} from "./utils/edit";

const InAppContent = ({ pageProps }: any) => {
  const { productId } = useParams();
  const location = useLocation();
  const { showToast } = useToast();
  const [suppressRedirect, setSuppressRedirect] = useState(false);
  const lastUpdateStatusRef = useRef<string | undefined>(undefined);
  const returnToParam = new URLSearchParams(location.search).get("returnTo");
  const returnTo =
    returnToParam && returnToParam.startsWith("/app/my-products")
      ? returnToParam
      : "/app/my-products";

  useEffect(() => {
    if (productId) {
      getMetadata({
        pageProps,
        // payload: "CLEAR"
      });
      getImagesGallery({
        pageProps,
        payload: "CLEAR",
      });

      getProductDetail({
        pageProps,
        payload: productId,
      });

      addNewProduct({
        pageProps,
        payload: "CLEAR",
      });
      editProduct({
        pageProps,
        payload: "CLEAR",
      });
    } else {
      history.replace("/app/my-products");
    }
  }, []);

  // Handle redirect only after successful product update
  useEffect(() => {
    const nextStatus = pageProps?.updateStoreProductRequest?.request_status;

    if (
      nextStatus === "UPDATE_PRODUCT_FAILURE" &&
      lastUpdateStatusRef.current !== "UPDATE_PRODUCT_FAILURE"
    ) {
      showToast({
        title: "Unable to update product",
        description:
          pageProps?.updateStoreProductRequest?.request_data?.error ||
          "Something went wrong while updating this product.",
        type: "error",
      });
      history.replace(returnTo);
    }

    lastUpdateStatusRef.current = nextStatus;
  }, [
    pageProps?.updateStoreProductRequest?.request_status,
    pageProps?.updateStoreProductRequest?.request_data?.error,
    returnTo,
    showToast,
  ]);

  useEffect(() => {
    if (
      !suppressRedirect &&
      pageProps?.updateStoreProductRequest?.request_status ===
      "UPDATE_PRODUCT_SUCCESS"
    ) {
      history.replace(returnTo);
      editProduct({
        pageProps,
        payload: "CLEAR",
      });
    }
  }, [pageProps?.updateStoreProductRequest?.request_status, returnTo, suppressRedirect]);

  return (
    <div className="inapp-content">
      <div className="page-content form-page">
        {/* <div className="addproduct-heading">
                    <h3>Edit Product</h3>
                    <div className="addproduct-top">Get the right market for your products. Edit your products here and get set to sell them on mamiMarket</div>
                </div> */}
        {pageProps?.getAProductRequest?.request_status ===
          "GET_A_PRODUCT_SUCCESS" &&
          pageProps?.getProductMetaDataRequest?.request_status ===
            "GET_PRODUCT_META_SUCCESS" && (
            <EditProductForm
              pageProps={pageProps}
              setSuppressRedirect={setSuppressRedirect}
              returnTo={returnTo}
            />
          )}
        {pageProps?.getAProductRequest?.request_status ===
          "GET_A_PRODUCT_PENDING" && <LoadingItem />}
        {pageProps?.getAProductRequest?.request_status ===
          "GET_A_PRODUCT_FAILURE" && (
          <AlertMsg
            type="error"
            message={pageProps?.getAProductRequest?.request_data?.error}
          />
        )}
        {pageProps?.getProductMetaDataRequest?.request_status ===
          "GET_A_PRODUCT_FAILURE" && (
          <AlertMsg
            type="error"
            message={pageProps?.getProductMetaDataRequest?.request_data?.error}
          />
        )}
      </div>
    </div>
  );
};
const EditProduct = (pageProps: any) => {
  // const { productId } = useParams();
  // useEffect(() => {

  //         getProductDetail({
  //             pageProps,
  //             payload: "CLEAR"
  //         })

  // }, [])
  return (
    <InAppTemplate
      pageHeadingTitle="Edit Product"
      showMainPageHeading={true}
      mainPageHeading={<MainHeader />}
      childComponent={<InAppContent pageProps={pageProps} />}
    />
  );
};

const mapDispatchToProps = {
  updateProductAction: storeActions.UpdateStoreProduct,
  getMetadataAction: storeActions.GetProductMetaData,
  getAttributeTemplatesAction: storeActions.GetAttributeTemplates,
  getAttributeTemplateDetailAction: storeActions.GetAttributeTemplateDetail,
  getImageGalleryAction: storeActions.GetImageGallery,
  getAProduct: storeActions.GetAProduct,
  uploadProductImageAction: storeActions.UploadProductImage,
};

const mapStateToProps = (state: any) => ({
  // return {
  // allImagesGallery: ()=>{
  //     return
  // },
  getProductMetaDataRequest: state.allProductReducers.getProductMetaDataReducer,
  getAttributeTemplatesRequest: state.allProductReducers.getAttributeTemplatesReducer,
  getAttributeTemplateDetailRequest: state.allProductReducers.getAttributeTemplateDetailReducer,
  updateStoreProductRequest: state.allProductReducers.updateStoreProductReducer,
  getImageGalleryRequest: state.allProductReducers.getImageGalleryReducer,
  createStoreProductRequest: state.allProductReducers.createStoreProductReducer,
  getAProductRequest: state.allProductReducers.getAProductReducer,
  updateProductImageRequest: state.allProductReducers.updateProductImageReducer,

  // };
});
export default connect(mapStateToProps, mapDispatchToProps)(EditProduct);
